import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { authStateReady } from "../utils/authState";

const MyVacanciesService = {
  
  async getMyVacancies() {
    try {
      const user = await authStateReady();
  
      if (!user) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return {
          vacancies: [],
          frozen_vacancies: []
        };
      }
  
      const token =
        await user.getIdToken();
  
      const response = await fetch(
        "https://europe-west3-hyper-e122e.cloudfunctions.net/get_my_vacancies",
        {
          method: "POST",
  
          headers: {
            "Content-Type":
              "application/json",
  
            Authorization:
              `Bearer ${token}`,
          },
  
          body: JSON.stringify({
            user_id: user.uid,
          }),
        }
      );
  
      if (
        response.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return {
          vacancies: [],
          frozen_vacancies: []
        };
      }
  
      if (!response.ok) {
        const errorText =
          await response.text();
  
        throw new Error(
          `Ошибка: ${response.status} ${errorText}`
        );
      }
  
      return await response.json();
  
    } catch (error) {
      console.error(
        "❌ getMyVacancies error:",
        error
      );
  
      return {
        vacancies: [],
        frozen_vacancies: []
      };
    }
  },

  /**
   * 🔹 Загружает изображение для вакансии (через универсальный upload_image)
   * @param {string} vacancyId - ID вакансии
   * @param {File} file - файл изображения
   * @returns {Promise<string>} - image_url
   */
  async uploadVacancyImage(vacancyId, file) {
    console.log("📤 Загружаем изображение вакансии:", vacancyId);

    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);

      const formData = new FormData();
      formData.append("type", "vacancy_image");
      formData.append("user_id", currentUser.uid);
      formData.append("vacancy_id", vacancyId);
      formData.append("vacancy_image", file);

      const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/upload_image", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("❌ Ошибка при загрузке:", data);
        throw new Error(data.error || "Ошибка при загрузке изображения");
      }

      console.log("✅ Изображение успешно загружено:", data.url);
      return data.url;

    } catch (error) {
      console.error("❌ uploadVacancyImage error:", error);
      throw error;
    }
  },

  async createVacancy(data) {
    console.log("📤 Отправка данных на create_vacancy...");
    console.log("📦 Данные до auth:", data);
  
    try {
      const user = await authStateReady();
  
      if (!user) {
        throw new Error("Пользователь не авторизован");
      }
  
      const token = await user.getIdToken(true);
  
      const payload = {
        ...data,
        vacancy_owner: user.uid,
      };
  
      console.log("📦 Payload createVacancy:", payload);
  
      const response = await fetch(
        "https://europe-west3-hyper-e122e.cloudfunctions.net/create_vacancy",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
  
      console.log("📬 Ответ от сервера:", response.status);
  
      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Ошибка:", response.status, errorText);
        throw new Error(`Ошибка при создании вакансии: ${response.status}`);
      }
  
      const result = await response.json();
  
      console.log("✅ Вакансия успешно создана:", result);
  
      return result;
    } catch (error) {
      console.error("❌ createVacancy error:", error);
      throw error;
    }
  },


    // ⚠️ ADMIN METHOD (используется в админке, без токена пользователя)

    async updateVacancy(data) {
    console.log("📤 Отправка данных на update_vacancy...");
    console.log("📦 Данные:", data);

    try {
      const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/update_vacancy", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      console.log("📬 Ответ от сервера получен:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Ошибка при обновлении вакансии:", response.status, errorText);
        throw new Error(`Ошибка при обновлении вакансии: ${response.status}`);
      }

      const result = await response.json();
      console.log("✅ Вакансия успешно обновлена:", result);
      return result;
    } catch (error) {
      console.error("❌ updateVacancy error:", error);
      throw error;
    }
  },

    async updateVacancyHashtags(vacancyId, hashtags) {
    console.log("✏️ Обновляем хэштеги для вакансии:", vacancyId, hashtags);

    try {
      const response = await fetch("https://europe-west3-hyper-e122e.cloudfunctions.net/update_vacancy_hashtags", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          vacancy_id: vacancyId,
          hashtags: hashtags
        })
      });

      console.log("📬 Ответ от сервера получен:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Ошибка при обновлении хэштегов:", response.status, errorText);
        throw new Error(`Ошибка при обновлении хэштегов: ${response.status}`);
      }

      const result = await response.json();
      console.log("✅ Хэштеги успешно обновлены:", result);
      return result;
    } catch (error) {
      console.error("❌ updateVacancyHashtags error:", error);
      throw error;
    }
  },

  // ✅ USER METHOD (используется в интерфейсе работодателя)

  async editMyVacancy(data) {
    console.log("📤 Отправка данных на edit_vacancy (user)...");
    console.log("📦 Данные:", data);
  
    try {
      const auth = getAuth();
      const user = auth.currentUser;
  
      if (!user) {
        throw new Error("Пользователь не авторизован");
      }
  
      const token = await user.getIdToken(true);
  
      const response = await fetch(
        "https://europe-west3-hyper-e122e.cloudfunctions.net/edit_vacancy",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // 🔐 ВАЖНО
          },
          body: JSON.stringify(data),
        }
      );
  
      console.log("📬 Ответ от сервера:", response.status);
  
      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ Ошибка при редактировании:", response.status, errorText);
        throw new Error(`Ошибка при редактировании вакансии: ${response.status}`);
      }
  
      const result = await response.json();
      console.log("✅ Вакансия успешно отредактирована:", result);
  
      return result;
  
    } catch (error) {
      console.error("❌ editMyVacancy error:", error);
      throw error;
    }
  },

// ❌ Удаление вакансии (для пользователя)
async deleteVacancy(vacancyId) {
  console.log("🗑 Удаляем вакансию:", vacancyId);

  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("Пользователь не авторизован");
    }

    const token = await user.getIdToken(true);

    const response = await fetch(
      "https://europe-west3-hyper-e122e.cloudfunctions.net/delete_vacancy",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          vacancy_id: vacancyId
        })
      }
    );

    console.log("📬 Ответ от сервера:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Ошибка:", response.status, errorText);
      throw new Error(`Ошибка при удалении вакансии: ${response.status}`);
    }

    const result = await response.json();
    console.log("✅ Вакансия удалена:", result);

    return result;

  } catch (error) {
    console.error("❌ deleteVacancy error:", error);
    throw error;
  }
},

async freezeVacancy(vacancyId) {
  console.log("🧊 Замораживаем вакансию:", vacancyId);

  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("Пользователь не авторизован");
    }

    const token = await user.getIdToken(true);

    const response = await fetch(
      "https://europe-west3-hyper-e122e.cloudfunctions.net/freeze_vacancy",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          vacancy_id: vacancyId
        })
      }
    );

    console.log("📬 Ответ freeze:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Ошибка freeze:", errorText);
      throw new Error("Ошибка при заморозке вакансии");
    }

    const result = await response.json();
    console.log("✅ Заморожена:", result);

    return result;

  } catch (error) {
    console.error("❌ freezeVacancy error:", error);
    throw error;
  }
},

async unfreezeVacancy(vacancyId) {
  console.log("♻️ Размораживаем вакансию:", vacancyId);

  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("Пользователь не авторизован");
    }

    const token = await user.getIdToken(true);

    const response = await fetch(
      "https://europe-west3-hyper-e122e.cloudfunctions.net/unfreeze_vacancy",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          vacancy_id: vacancyId
        })
      }
    );

    console.log("📬 Ответ unfreeze:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Ошибка unfreeze:", errorText);
      throw new Error("Ошибка при восстановлении вакансии");
    }

    const result = await response.json();
    console.log("✅ Восстановлена:", result);

    return result;

  } catch (error) {
    console.error("❌ unfreezeVacancy error:", error);
    throw error;
  }
}

};

export default MyVacanciesService;